import React, { useState, useEffect } from 'react'
import GMap from './Signup/GMap';
import { useLocation, Link } from "react-router-dom";
import axios from 'axios';
import {
	CCard, CCol, CRow, CCardHeader,
	CCardTitle, CCardText, CCardBody,
	CCardSubtitle,
} from 'compat/coreui';


function SearchStrains(props) {

	const [sellerData, setSellerData] = useState([]);
	const [params, setParams] = useState({});
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0)
		setParams(location.state || {});
		getBusiness(location.state || {});
	}, [location]);

	const getBusiness = (paramsOne) => {
		console.log('inside getbusiness', paramsOne)
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/sellers`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('token')
			},
			params: paramsOne
		}).then(res => {
			console.log("search business page", res)
			if (res.data.status === 200) {
				setSellerData(res.data.sellers)
			}
		}).catch(console.log)
	}


	return (
		<>
			<div>
				<div className="body_wrap has_map">
					<div>
						<div className="index_none2 remove_onreload">
							<div className="seller-details m-5">
								<h2>Businesses</h2>
								<CRow className="seller-cardRow">
									{sellerData.map((item, index) => {
										return (<CCol sm="3" className="m-auto" key={index}>
											<Link to={`/businessnew/${item._id}`}>
												<CCard>
													<CCardBody className="d-flex p-0">
														<img style={{ maxWidth: "50px" }} src={item.image ? "https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + item.image : "/images/44.png"} />
														<div className="bdetails-section">
															<CCardTitle>
																<span style={{ wordBreak: 'break-all', fontWeight: "600", color: "black", fontSize: "17" }}>{item.businessName}</span><br />
																<span>{item.businessType}</span><br />
																<span>{item.city}</span><br />
																<span>{item.state}</span><br />
															</CCardTitle>
															<span className="rate-section">
																<img src="/images/rating.jpg" width="62" height="25" />
															</span>
														</div>
													</CCardBody>
												</CCard>
											</Link>
										</CCol>)
									})}
								</CRow>
							</div>
                        </div>
					</div>
				</div>
			</div>
		</>
	)
}


export default SearchStrains;